<app-referrals-ehr-listing
  [loading]="loadingReferralMatchOptions"
  [editable]="true"
  [patientPrescriber]="patientPrescriber"
  [provider]="patientAttachment.provider"
  [referralMatchOptions]="referralMatchOptions"
  (newEhrReferralVerification)="onNewEhrReferralVerification($event)"
  (ehrReferralVerificationEdited)="onEhrReferralVerificationEdited($event)"
  (referralVerificationChange)="onReferralVerificationChange($event)" />
